import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const etapes = [
  "Diagnostic complet du moteur Somfy et du point de commande",
  "Démontage du moteur tubulaire défectueux dans le coffre",
  "Installation du nouveau moteur compatible (io ou RTS)",
  "Recâblage et connexion des fins de course",
  "Reprogrammation des télécommandes et interrupteurs",
  "Tests de montée, descente et arrêt d'urgence",
];

export default function Remplacement() {
  return (
    <section className="bg-[#F4F8FB] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative rounded-xl overflow-hidden border border-[#E2E8F0]">
            <ImagePlaceholder
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/6e59175df2bef8877f2fb7994f0754dc.jpeg"
              alt="Technicien remplaçant un moteur Somfy dans un coffre de volet roulant à Strasbourg"
              className="w-full h-[340px] md:h-[420px]"
              loading="lazy"
            />
          </div>
          <div>
            <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-5">
              Remplacement du moteur Somfy étape par étape
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Le remplacement d'un moteur Somfy suit un protocole strict pour garantir un résultat fiable et durable. Nos techniciens commencent par un diagnostic complet du moteur tubulaire et du point de commande, puis démontent l'ancien moteur sans endommager le tablier ni le coffre. L'installation du nouveau moteur se fait avec des fixations adaptées à la dimension du volet et au poids du tablier.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-6">
              Une fois le moteur posé, nous recâblons l'ensemble des connexions électriques, réglons les fins de course et reprogrammons vos télécommandes Somfy (io ou RTS) ainsi que vos interrupteurs muraux. L'intervention se termine par une série de tests pour vérifier la montée, la descente et la fonction d'arrêt d'urgence. Nous vous remettons un document de garantie et repartons avec l'ancien moteur pour recyclage.
            </p>
            <ul className="space-y-3 mb-8">
              {etapes.map((etape) => (
                <li key={etape} className="flex items-center gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#00B3A4]/10 shrink-0">
                    <i className="ri-check-line text-[#00B3A4] text-sm"></i>
                  </span>
                  <span className="text-[#143A66] text-base font-medium">{etape}</span>
                </li>
              ))}
            </ul>
            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#00B3A4] text-white px-6 py-4 rounded-lg font-semibold text-base hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}